import { render, staticRenderFns } from "./MallAppletConfig.vue?vue&type=template&id=f715629a"
import script from "./MallAppletConfig.vue?vue&type=script&lang=js"
export * from "./MallAppletConfig.vue?vue&type=script&lang=js"
import style0 from "./MallAppletConfig.vue?vue&type=style&index=0&id=f715629a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports